import styled from 'styled-components';
import AdaptButton from 'components/base/Button';

const ConfirmSplitButton = styled(AdaptButton)`
  && {
    font-weight: 700;
    margin-top: 16px;
    height: 56px;
  }
`;

const ShareLinkButton = styled(AdaptButton)`
  && {
    font-weight: 700;
    margin-top: 30px;
    height: 56px;
  }
`;

const TitleContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  position: absolute;
  top: 29px;
  max-width: 75%;
`;

const Title = styled.div`
  ${({ theme: { font } }) => font.mainFont()};
  color: ${({ theme: { color } }) => color.gray_700};
  font-weight: 500;
  font-size: 18px;
  line-height: 31px;
`;

const SubTitle = styled.div`
  color: ${({ theme: { color } }) => color.gray_400};
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`;

const SplitBillQrCodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const QrCodeContainer = styled.div`
  display: flex;
  margin-top: 30px;
  justify-content: center;
  background: ${({ theme: { color } }) => color.white_600};
  max-width: 295px;
  max-height: 295px;
  padding: 20px;
`;

export {
  SplitBillQrCodeContainer,
  TitleContainer,
  Title,
  SubTitle,
  QrCodeContainer,
  ConfirmSplitButton,
  ShareLinkButton,
};
